import { Converter } from '../types/converter';

export const timeConverter: Converter = {
  id: 'time',
  name: 'Time Converter',
  icon: 'Clock',
  categories: ['common'],
  units: [
    // Base SI unit
    { name: 'Second', symbol: 's', factor: 1 },
    
    // Common time units
    { name: 'Millisecond', symbol: 'ms', factor: 0.001 },
    { name: 'Minute', symbol: 'min', factor: 60 },
    { name: 'Hour', symbol: 'h', factor: 3600 },
    { name: 'Day', symbol: 'd', factor: 86400 },
    { name: 'Week', symbol: 'week', factor: 604800 },
    { name: 'Month', symbol: 'month', factor: 2629746 },  // Average month (365.2425/12 days)
    { name: 'Year', symbol: 'y', factor: 31556952 },      // Gregorian year (365.2425 days)
    { name: 'Decade', symbol: 'decade', factor: 315569520 },
    { name: 'Century', symbol: 'century', factor: 3155695200 },
    { name: 'Millennium', symbol: 'millennium', factor: 31556952000 },
    
    // Small time units
    { name: 'Microsecond', symbol: 'µs', factor: 1e-6 },
    { name: 'Nanosecond', symbol: 'ns', factor: 1e-9 },
    { name: 'Picosecond', symbol: 'ps', factor: 1e-12 },
    { name: 'Femtosecond', symbol: 'fs', factor: 1e-15 },
    { name: 'Attosecond', symbol: 'as', factor: 1e-18 },
    { name: 'Shake', symbol: 'shake', factor: 1e-8 },
    
    // Astronomical time units
    { name: 'Month (synodic)', symbol: 'synodic month', factor: 2551443.84 },  // 29.530589 days
    { name: 'Year (Julian)', symbol: 'Julian year', factor: 31557600 },        // Exactly 365.25 days
    { name: 'Year (leap)', symbol: 'leap year', factor: 31622400 },            // Exactly 366 days
    { name: 'Year (tropical)', symbol: 'tropical year', factor: 31556925.216 }, // 365.242190 days
    { name: 'Year (sidereal)', symbol: 'sidereal year', factor: 31558149.504 }, // 365.256363004 days
    { name: 'Day (sidereal)', symbol: 'sidereal day', factor: 86164.09053 },
    { name: 'Hour (sidereal)', symbol: 'sidereal hour', factor: 3590.170219 },
    { name: 'Minute (sidereal)', symbol: 'sidereal minute', factor: 59.836170 },
    { name: 'Second (sidereal)', symbol: 'sidereal second', factor: 0.9972696 },
    
    // Other time periods
    { name: 'Fortnight', symbol: 'fortnight', factor: 1209600 },               // 14 days
    { name: 'Septennial', symbol: 'septennial', factor: 220898664 },           // 7 years
    { name: 'Octennial', symbol: 'octennial', factor: 252455616 },             // 8 years
    { name: 'Novennial', symbol: 'novennial', factor: 284012568 },             // 9 years
    { name: 'Quindecennial', symbol: 'quindecennial', factor: 473354280 },     // 15 years
    { name: 'Quinquennial', symbol: 'quinquennial', factor: 157784760 },       // 5 years
    
    // Physical constant
    { name: 'Planck time', symbol: 'ℓP/c', factor: 5.391247e-44 }
  ]
};
